
import { defineComponent } from 'vue'
import ModalBase from '@/views/modal/ModalBase.vue'

export default defineComponent({
  components: {
    ModalBase
  },
  props: {
    targetName: {
      type: String,
      required: true
    },
    targetObj: {
      type: Object,
      required: true
    }
  },
  emits: {
    dismiss: () => true,
    shouldDelete: (targetObj: object) => true
  },
  setup (props, { emit }) {
    const dismiss = () => {
      emit('dismiss')
    }

    const onClickedDelete = () => {
      emit('shouldDelete', props.targetObj)
    }

    return {
      dismiss,
      onClickedDelete
    }
  }
})
